import React from "react";
import { useIntl } from "react-intl";
import { ReactSVG } from "react-svg";
import notificationIcon from "../../../../../../assets/images/layout/notification-icon.svg";
import activeIndicatorIcon from "../../../../../../assets/images/common/active-indicator.svg";

const NotificationIcon = ({ isActive, showNotificationBanner }) => {
    const intl = useIntl();
    return (
        <button type="button" aria-label={intl.formatMessage({ id: "teamroom.notifications.title" })} className="relative cursor-pointer rounded-full" onClick={showNotificationBanner}>
            <ReactSVG className="text-standart-ocean hover:text-light-purple active:text-black" src={notificationIcon} />
            {isActive && (
                <ReactSVG className="absolute -right-0.5 -top-0.5" src={activeIndicatorIcon} />
            )}
        </button>
    );
};

export default NotificationIcon;
